import React from "react";
import { Grid, Row, Col, Space } from "antd";
import AppLayout from "../components/AppLayout";
import styles from "./TNC.module.css";
import { useHistory } from "react-router-dom";

const { useBreakpoint } = Grid;

const TNC = () => {
  const breakpoint = useBreakpoint();
  const history = useHistory();

  return (
    <AppLayout backgroundColor="rgba(0, 0, 0, 0.20)">
      <div style={{ height: "auto" }}>
        <div
          className={styles.tncContainer}
          style={{
            paddingBottom: breakpoint?.md ? 148 : 40,
          }}
        >
          <Row
            align="middle"
            style={{
              paddingLeft: 18,
              paddingRight: 18,
              marginTop: breakpoint?.md ? 48 : 40,
            }}
            className={`${styles.ft_18} ${styles.textBtn}`}
            onClick={() => {
              history.goBack();
            }}
          >
            <img
              src="/images/back.png"
              alt=""
              style={{ width: 18, height: 18, marginRight: 4 }}
            />
            Back
          </Row>
          <Row
            className={styles.ft_44_900}
            style={{
              paddingLeft: 18,
              paddingRight: 18,
              paddingTop: breakpoint?.md ? 148 : 32,
            }}
          >
            Terms & Conditions
          </Row>

          <Space
            direction="vertical"
            style={{ marginTop: 20, paddingLeft: 18, paddingRight: 18 }}
            size={24}
          >
            {breakpoint?.md && (
              <>
                <div className={styles.ft_18}>
                  Welcome to our web3 gamefi project! By accessing or using our
                  platform, you agree to be bound by these Terms and Conditions,
                  which govern your use of the platform.
                </div>
                <div className={styles.ft_18}>
                  Our platform and all its contents are owned by us and are
                  protected by intellectual property laws. You agree not to
                  copy, distribute, or reproduce any content on our platform
                  without our prior written consent.
                </div>
                <div className={styles.ft_18}>
                  Welcome to our web3 gamefi project! By accessing or using our
                  platform, you agree to be bound by these Terms and Conditions,
                  which govern your use of the platform.
                </div>
                <div className={styles.ft_18}>
                  Our platform and all its contents are owned by us and are
                  protected by intellectual property laws. You agree not to
                  copy, distribute, or reproduce any content on our platform
                  without our prior written consent.
                </div>
              </>
            )}

            {!breakpoint?.md && (
              <>
                <div className={styles.ft_18}>
                  The products and services of Live4Well are not intended for
                  individuals in China.
                </div>
                <div className={styles.ft_18}>
                  Nothing on Live4Well is intended to be construed as a
                  solicitation to any individual in China.
                </div>
                <div className={styles.ft_18}>
                  Live4Well accepts no liability for losses to any party arising
                  out of, or in connection with, any order for any of the
                  products or services, including NFTs, detailed on this
                  website/application.
                </div>
              </>
            )}
          </Space>
        </div>
      </div>
    </AppLayout>
  );
};

export default TNC;
